import { Controller } from "@hotwired/stimulus";

let lastScroll: number | null = null;
// Connects to data-controller="calendar"
export default class extends Controller {
  static targets = ["onTop", "onBottom"];

  declare onBottomTarget: HTMLElement;
  declare hasOnBottomTarget: boolean;
  declare onTopTarget: HTMLElement;
  declare hasOnTopTarget: boolean;

  connect() {
    window.addEventListener(
      "wheel",
      (e) => {
        this.eventHandling(-e.deltaY);
      },
      { passive: true },
    );
    window.addEventListener("touchstart", (e) => {
      lastScroll = e.touches[0].clientY;
    });

    // window.addEventListener(
    //   "touchmove",
    //   (e) => {
    //     this.eventHandling(e.touches[0].clientY - (lastScroll || 0));
    //   },
    //   { passive: true },
    // );
  }

  eventHandling(deltaY: number) {
    const scrolled = window.scrollY;
    const previousScrolled = lastScroll;
    lastScroll = scrolled;
    if (scrolled != previousScrolled) return;

    const visible = window.innerHeight - 10;
    const full = document.documentElement.scrollHeight;
    this.clickTarget(scrolled >= full - visible && deltaY < 0, scrolled == 0 && deltaY > 0);
  }

  clickTarget(isBottom: boolean, isTop: boolean) {
    if (isBottom && this.hasOnBottomTarget) {
      this.onBottomTarget.click();
      this.disableTargets();
    } else if (isTop && this.hasOnTopTarget) {
      this.onTopTarget.click();
      this.disableTargets();
    }
  }

  disableTargets() {
    if (this.hasOnBottomTarget) {
      this.onBottomTarget.removeAttribute("href");
      this.onBottomTarget.setAttribute("aria-disabled", "true");
    }
    if (this.hasOnTopTarget) {
      this.onTopTarget.removeAttribute("href");
      this.onTopTarget.setAttribute("aria-disabled", "true");
    }
  }
}
